var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { collectHitTargets, getWorldBounds } from './bounds';
var SpatialIndex = /** @class */ (function () {
    function SpatialIndex(cellSize) {
        if (cellSize === void 0) { cellSize = 64; }
        this.grid = new Map();
        this.entries = [];
        this.stale = true;
        this.cellSize = cellSize;
    }
    SpatialIndex.prototype.markStale = function () {
        this.stale = true;
    };
    SpatialIndex.prototype.rebuild = function (root) {
        var e_1, _a;
        this.grid.clear();
        this.entries = collectHitTargets(root, []);
        try {
            for (var _b = __values(this.entries), _c = _b.next(); !_c.done; _c = _b.next()) {
                var node = _c.value;
                this.insert(node);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.stale = false;
    };
    SpatialIndex.prototype.ensureFresh = function (root) {
        if (this.stale)
            this.rebuild(root);
    };
    SpatialIndex.prototype.insert = function (node) {
        var e_2, _a;
        var b = getWorldBounds(node, 0);
        try {
            for (var _b = __values(this.cellsForBounds(b)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var bucket = this.grid.get(key);
                if (bucket)
                    bucket.push(node);
                else
                    this.grid.set(key, [node]);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    SpatialIndex.prototype.cellsForBounds = function (b) {
        var cs = this.cellSize;
        var x0 = Math.floor(b.x / cs);
        var y0 = Math.floor(b.y / cs);
        var x1 = Math.floor((b.x + b.width) / cs);
        var y1 = Math.floor((b.y + b.height) / cs);
        var keys = [];
        for (var x = x0; x <= x1; x++) {
            for (var y = y0; y <= y1; y++) {
                keys.push("".concat(x, ",").concat(y));
            }
        }
        return keys;
    };
    /** Candidates at a world point (deduped, high z-index first). */
    SpatialIndex.prototype.queryPoint = function (x, y) {
        var key = "".concat(Math.floor(x / this.cellSize), ",").concat(Math.floor(y / this.cellSize));
        var bucket = this.grid.get(key);
        if (!bucket)
            return [];
        var seen = new Set();
        var out = [];
        for (var i = bucket.length - 1; i >= 0; i--) {
            var node = bucket[i];
            if (seen.has(node.id))
                continue;
            seen.add(node.id);
            out.push(node);
        }
        out.sort(function (a, b) { return b.zIndex - a.zIndex; });
        return out;
    };
    Object.defineProperty(SpatialIndex.prototype, "size", {
        get: function () {
            return this.entries.length;
        },
        enumerable: false,
        configurable: true
    });
    SpatialIndex.prototype.clear = function () {
        this.grid.clear();
        this.entries = [];
        this.stale = true;
    };
    return SpatialIndex;
}());
export { SpatialIndex };
